import React from "react"
import './Button.scss'

const ButtonsHolder = props =>{

    const {variant, orientation, children} = props
    
    const setOrientation = (orientation) => {

        switch(orientation){
            default:
            case 'left': return 'flex-start' 
            case 'right': return 'flex-end'
            case 'center': return 'flex-center'
        }

    }
    const setVariant = (variant) => {

        switch(variant){
            default:
            case 'row': return 'flex-row'
            case 'column': return 'flex-column'
            case 'fixed-bottom': return 'fixed-bottom'
        }

    }
    
    return(
        <div className={`nova-btn-holder ${setOrientation(orientation)} ${setVariant(variant)}`}>
            {children}
        </div>
    )
}

export default ButtonsHolder;